"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create_document_from_file_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const main_1 = require("../../../main");
const document_1 = require("../../document");
const create_document_from_file_1 = require("../../../../../api/calls/document/create_document_from_file");
exports.create_document_from_file_thunk = (0, toolkit_1.createAsyncThunk)("documents/thunks/create_document_from_file_thunk", (arg, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const { data, callback } = arg;
    dispatch((0, document_1.setIsLoading)(true));
    const response = yield (0, create_document_from_file_1.create_document_from_file)(data);
    dispatch((0, document_1.setIsLoading)(false));
    if (response.success) {
        const payload = response.content.document;
        dispatch((0, document_1.updateDocument)(payload));
        dispatch((0, document_1.setSelectedDocument)(payload));
        if (callback)
            callback(payload);
    }
    else {
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
    }
}));
